export const splitBillSteps = {
  options: 'options',
  items: 'items',
  divide: 'divide',
  custom: 'custom',
};
